import type { ImageProps } from 'next/image';

import { SBPositionBasedOnFocalPoint } from '@utils/SBImageLoader';

export function getFocalPoint(src: ImageProps['src'], focal?: string) {
  if (typeof src === 'string' && src.startsWith('https://a.storyblok.com')) {
    return SBPositionBasedOnFocalPoint(src, focal);
  }
  return null;
}
